<template>
  <el-row :gutter="10" class="w100">
    <section v-for="(item, index) in siftData" :key="index">
      <component ref="siftComp" :is="compSiftName(item.type)" :type-data="item" :width="width" :w50="w50 ? w50 : false"></component>
    </section>
    <slot />
  </el-row>
</template>

<script>
import TextComp from "@/components/CompSift/TextComp";
import SelectComp from "@/components/CompSift/SelectComp";
import SelectsComp from "@/components/CompSift/SelectsComp";
import DateComp from "@/components/CompSift/DateComp";
import TimeComp from "@/components/CompSift/TimeComp";
import DateTimeComp from "@/components/CompSift/DateTimeComp";
import BEDateComp from "@/components/CompSift/BEDateComp";
import RadioComp from "@/components/CompSift/RadioComp";
import CascaderComp from "@/components/CompSift/CascaderComp";

export default {
  name: "sift-comp",
  props: ["sift-data", "searching", "w50"],
  components: {
    TextComp,
    SelectComp,
    SelectsComp,
    DateComp,
    TimeComp,
    DateTimeComp,
    BEDateComp,
    RadioComp
  },
  data() {
    return {
      width: "auto"
    };
  },
  created() {
    const arr = this.siftData.map(val => val.label.length);
    this.width = Math.max(...arr) + 1;
    // console.log(this.width);
  },
  computed: {},
  mounted() {},
  methods: {
    clickSearchBtn() {
      var obj = {};
      // console.log(this.siftData);
      for (const i in this.siftData) {
        // console.log(this.siftData[i].key);
        if (this.siftData[i].type == "bedate") {
          const arr = this.siftData[i].key.split(",");
          if (this.$refs.siftComp[i].value) {
            obj[arr[0]] = this.$refs.siftComp[i].value[0];
            obj[arr[1]] = this.$refs.siftComp[i].value[1];
          } else {
            obj[arr[0]] = "";
            obj[arr[1]] = "";
          }
        } else if (this.siftData[i].type == "cascader") {
          const arr = this.$refs.siftComp[i].getValue();
          for (const item of arr) {
            const name = item.key;
            obj[name] = item.value;
          }
        } else {
          obj[this.siftData[i].key] = this.$refs.siftComp[i].value;
        }
      }
      return obj;
    },
    compSiftName(value) {
      switch (value) {
        case "text":
          return TextComp;
          break;
        case "select":
          return SelectComp;
          break;
        case "selects":
          return SelectsComp;
          break;
        case "date":
          return DateComp;
          break;
        case "time":
          return TimeComp;
          break;
        case "datetime":
          return DateTimeComp;
          break;
        case "bedate":
          return BEDateComp;
          break;
        case "radio":
          return RadioComp;
          break;
        case "cascader":
          return CascaderComp;
          break;
        default:
          return TextComp;
          break;
      }
    }
  }
};
</script>

<style scoped>
</style>
